module.exports = __webpack_public_path__ + "media/images/main_arena_weekday-76fca50a1b1b2950f218dde8fced1808.png";